import React from 'react';
import styled from 'styled-components';
import { Image, Snip, getSnip } from 'launchpad';
import theme from 'styles/theme.js';

var StyledBgImageHero = styled.div`
  padding: 25px 0;
  background-color: ${theme.colors.blue.mediumDark};
  .container {
    >.row {
      margin-bottom: 0;
      >div {
        padding: 25px 0;
      }
      >div + div {
        padding-top: 0;
      }
    }
  }
`;

export default class CtaBg extends React.Component {
  render() {
    return (
      <StyledBgImageHero className="">
        {/* Need bg image for bg-img-hero */}
        <div className="container">
          <div className="row align-items-lg-center text-center text-lg-left cp-2">
            <div className="col-lg-7">
              <Snip component='h2' className='text-white' name="content-cta-heading" page={this.props.page} />
              <Snip className="lead text-white mb-0" name="content-cta-main-content" page={this.props.page} />
            </div>

            <div className="col-lg-5 text-lg-right">
              <a className="btn btn-primary mb-2 mb-sm-0 mr-sm-2" href="#"><Snip inline name="content-cta-cta1" page={this.props.page} /></a>
              <a className="btn btn-primary mb-2 mb-sm-0 mr-sm-2" href="#"><Snip inline name="content-cta-cta-2" page={this.props.page} /></a>
            </div>
          </div>
        </div>
      </StyledBgImageHero>
    )
  }
}
